import { call, put, takeLatest } from 'redux-saga/effects'
import { GET_ORDERS } from '../App/constants'
import { getOrdersSuccess, getOrdersError } from '../App/actions'
import request from '../../utils/request'

const tgdApiPath = process.env.REACT_APP_TGDAPI_SERVER || ''

export function * fetchOrders ({ token }) {
  const url = `${tgdApiPath}/order`
  try {
    const data = yield call(request, url, {
      method: 'GET',
      headers: { 'Authorization': `Bearer ${token}` },
    })
    const orders = Array.isArray(data) ? data : (data.orders || [])
    yield put(getOrdersSuccess(orders))
  } catch (err) {
    yield put(getOrdersError(err))
  }
}

export function * getOrdersSaga () {
  yield takeLatest(GET_ORDERS, fetchOrders)
}
